import { render, staticRenderFns } from "./CustomTemplate.vue?vue&type=template&id=6a18b6e1"
import script from "./CustomTemplate.vue?vue&type=script&lang=js"
export * from "./CustomTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports